import MuiBackdrop, { BackdropProps } from '@mui/material/Backdrop';

export interface IBackdropProps extends BackdropProps {}

const Backdrop = (props: IBackdropProps): JSX.Element => {
  return <MuiBackdrop {...props} />;
};

export default Backdrop;
